import { useEffect, useMemo, useState } from 'react';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { useGetColumns } from '../hooks/useGetColumns';
import { useGetFilters } from '../hooks/useGetFilters';
import { useGetRows } from '../hooks/useGetRows';
import { DocumentosSAPFilters } from './DocumentosSAPFilters';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { useMutation } from '@apollo/client/react';
import { PROCESAR_DOCUMENTOS_SAP } from '../../../data/graphQL/mutations/DocumentosSAP/procesarDocumentosSap';
import toast from 'react-hot-toast';

export const DocumentosSAPContent = ({ allowedWrite, setChildrenAction }) => {
    const [isRefetchRequired, setIsRefetchRequired] = useState(true);
    const [rowSelectionModel, setRowSelectionModel] = useState([]);

    const {
        filters,
        handleChangeFilters,
        estados
    } = useGetFilters();

    const {
        rows,
        setRows,
        loading,
        totalCount,
        handleSearch
    } = useGetRows(filters, setIsRefetchRequired);

    const columns = useGetColumns();

    const [procesarDocumentosSap, { loading: loadingProcesar }] = useMutation(PROCESAR_DOCUMENTOS_SAP);

    const estadoEnviadosId = useMemo(() => estados?.find(e => e.displayName === 'Enviados')?.id, [estados]);

    useEffect(() => {
        handleSearch(true);
    }, []);

    const handleFilters = (name, value) => {
        handleChangeFilters(name, value);
        setRowSelectionModel([]);
        setRows([]);
        setIsRefetchRequired(true);
    }

    const handleSelectionModelChange = (ids) => {
        setRowSelectionModel(ids);
    };

    const handleProcess = async () => {

        const documentos = rows
            .filter(row => rowSelectionModel.includes(row.numeroPedido))
            .map(row => ({
                numeroDocumento: row.numeroDocumento,
                factura: row.factura,
                remito: row.remito
            }));

        await procesarDocumentosSap({
            variables: {
                documentos
            }
        }).then((res) => {
            if (res?.data?.procesarDocumentosSap?.length > 0) {
                toast.success('Documentos procesados correctamente');
                setRowSelectionModel([]);
                handleSearch();
            }
            else {
                toast.error('Error al procesar los documentos seleccionados. Intenta nuevamente.');
            }
        }).catch((err) => {
            toast.error('Error al procesar los documentos seleccionados. Intenta nuevamente.');
        });
    }

    useEffect(() => {
        if (filters.idEstado === estadoEnviadosId || !allowedWrite) {
            setChildrenAction(null);
            return;
        }

        setChildrenAction(() => (
            <CustomButton
                onClick={() => handleProcess()}
                variant='contained'
                disabled={rowSelectionModel.length === 0}
                isLoading={loadingProcesar}
            >
                Procesar
            </CustomButton>
        ));
    }, [
        setChildrenAction,
        estadoEnviadosId,
        filters.idEstado,
        rowSelectionModel,
        loadingProcesar,
        allowedWrite
    ]);

    return (
        <div>
            <DocumentosSAPFilters
                filters={filters}
                handleChangeFilters={handleFilters}
                handleSearch={handleSearch}
                disableFilters={loading || loadingProcesar}
                estados={estados}
            />
            <DataGridGenerico
                entityId='numeroPedido'
                rows={rows}
                columns={columns}
                totalCount={totalCount}
                loading={loading}
                checkboxSelection={filters?.idEstado !== estadoEnviadosId && allowedWrite}
                rowSelectionModel={rowSelectionModel}
                onRowSelectionModelChange={handleSelectionModelChange}
                toolbar={false}
                localeText={{
                    noRowsLabel: isRefetchRequired ?
                        'Haz click en "Buscar" para aplicar los nuevos filtros' :
                        "Sin filas"
                }}
            />
        </div>
    );
}